/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GetSupportedAppError = {
  errorType: ComHubspotUnifiedAccountApiModelsAppsGetsupportedappGetSupportedAppErrorIF.ErrorType;
  extraDetailsMessage?: string;
  upstreamError?: UAuthUpstreamError;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetSupportedAppRequest = { appId: number };

export type GetSupportedAppResponse = { supportedApp: App };

export namespace ComHubspotUnifiedAccountApiModelsAppsGetsupportedappGetSupportedAppErrorIF {
  export type ErrorType = 'UNKNOWN' | 'APP_NOT_FOUND' | unhandledEnumCase;
}

export type ListSupportedAppsError = {
  errorType: ComHubspotUnifiedAccountApiModelsAppsListsupportedappsListSupportedAppsErrorIF.ErrorType;
  extraDetailsMessage?: string;
  upstreamError?: UAuthUpstreamError;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ListSupportedAppsRequest = {};

export type ListSupportedAppsResponse = { supportedApps: Default<App[]> };

export namespace ComHubspotUnifiedAccountApiModelsAppsListsupportedappsListSupportedAppsErrorIF {
  export type ErrorType = 'UNKNOWN' | unhandledEnumCase;
}

export type App = {
  appId: number;
  authenticatorId: string;
  name: string;
  iconUrl?: string;
  extensionIconUrl?: string;
  multiAccount: Default<boolean>;
  migrationOrigin?: MigrationOrigin;
};

export type MigrationOrigin =
  | 'OAUTHOR'
  | 'MCP'
  | 'AI_API_KEY_APPS'
  | unhandledEnumCase;

export type UAuthUpstreamError = {
  upstreamRequestId?: string;
  upstreamErrorMessageInterpretation?: string;
};

export type ListSupportedAppsRequestType = Requestify<ListSupportedAppsRequest>;
export type ListSupportedAppsResponseType = ListSupportedAppsResponse;
export type ListSupportedAppsErrorType = ListSupportedAppsError &
  HubspotMetadata;
export const listSupportedAppsRpc: ChirpAvroRpcDetails<
  ListSupportedAppsRequestType,
  ListSupportedAppsResponseType,
  ListSupportedAppsErrorType,
  false
> = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AppRpc',
  rpcName: 'listSupportedApps',
  auth: 'app',
  fingerprint: 'PEFzqXzsoBzdvyshNQmtC39-XLLiJVZ0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSupportedAppRequestType = Requestify<GetSupportedAppRequest>;
export type GetSupportedAppResponseType = GetSupportedAppResponse;
export type GetSupportedAppErrorType = GetSupportedAppError & HubspotMetadata;
export const getSupportedAppRpc: ChirpAvroRpcDetails<
  GetSupportedAppRequestType,
  GetSupportedAppResponseType,
  GetSupportedAppErrorType,
  false
> = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AppRpc',
  rpcName: 'getSupportedApp',
  auth: 'app',
  fingerprint: 'EfC2_cXrvnUyksjrF6Te1sNkGmZ1Bl6E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
